<planone-search-input
  class="search-term-input"
  [cacheKey]="cacheKey"
  [options]="searchSuggestions"
  [size]="size"
  [asYouTypeResultWithIcon]="true"
  [hasIconOnlyWithOverlayMobileTemplate]="true"
  [placeholderText]="placeholder"
  (searchFieldChanged)="onSearchTermChanged($event)"
  (searchFieldSubmitted)="onSearchTermSubmitted()"></planone-search-input>
